<template>
  <div
    :class="$style.avatarStyleContainer"
  >
    <label
      :class="$style.chooserLabel"
    >
      Display Option:
    </label>
    <div>
      <TabList
        ref="tabsList"
        :activeTab="activeTab"
        :class="$style.tabContainer"
        :customActiveTabStyle="$style.activeTabHeader"
        :customNavStyle="$style.navList"
        :customTabStyle="$style.tabHeader"
        :tabs="tabs"
        @active-tab-change="toggleActiveTab"
      />
    </div>
  </div>
</template>
<script>
import { StoreModelMap } from 'client/util/Constants';
import { applicationModelFields, colorTypes } from 'client/util/Constants/ApplicationConstants';
import { cloneDeep } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import ColorPicker from 'client/components/Applications/ColorPicker';
import ImageUploader from 'client/components/Applications/ImageUploader';
import ItemTypeConstants from 'client/util/Constants/ItemTypeConstants';
import ModalEventBus from 'components/Modal/ModalEventBus';
import TabList from 'components/TabList/TabList.vue';

const { ItemTypeConsts } = ItemTypeConstants;
const { application } = ItemTypeConsts;
const applicationModel = StoreModelMap[application];

const { COLOR, LOGO } = applicationModelFields;
const { TEAL } = colorTypes;

export default {
  name: 'ApplicationAvatarChooser',

  components: {
    TabList,
  },

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  data() {
    return {
      activeTab: 0,
      previousColor: undefined,
      tabs: [
        {
          component: ImageUploader,
          componentProps: {
            parentType: this.parentType,
          },
          title: 'Logo',
        }, {
          component: ColorPicker,
          componentProps: {
            handleColorChange: this.handleColorChange,
            parentType: this.parentType,
          },
          title: 'Color Indicator',
        },
      ],
    };
  },

  computed: {
    ...mapGetters(applicationModel, [
      'isItemBeingUpdated',
      'templateLogoUrl',
    ]),

    ...mapState(applicationModel, [
      'appLogo',
      'item',
    ]),
  },

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options);
  },

  created() {
    this.handleCreated();
  },

  methods: {
    ...mapActions(applicationModel, ['setApplicationLogo']),

    handleAvatarValueChange({ value, tabName }) {
      const avatarValue = tabName === 'color' ? value : '';
      this.setItemField({ key: 'color', value: avatarValue });

      if (this.item.logo.color) {
        const { logo } = cloneDeep(this.item);
        logo.color = avatarValue;
        this.setItemField({ key: 'logo', value: logo });
      }
    },

    handleColorChange(color) {
      const params = { value: color, tabName: COLOR };
      this.previousColor = color;
      this.handleAvatarValueChange({ ...params });
    },

    handleContinue(tabName, selectedTab) {
      this.handleTabChange(tabName, selectedTab);
      this.setApplicationLogo(null);
      ModalEventBus.close();
    },

    handleCreated() {
      /**
       * @todo Change the current behaviour of updating the color value,
       * once we have already replaced the BackBone model with the ApplicationCollection store.
       */
      if (this.item.color === undefined) {
        this.setItemField({ key: 'color', value: '' });
      }
      this.setActiveTab();
      this.setPreviousColor();
    },

    handleTabChange(tabName, selectedTab) {
      this.activeTab = selectedTab;
      const value = this.previousColor;
      this.handleAvatarValueChange({ value, tabName });
    },

    setActiveTab() {
      if (this.item.name === 'saml2'
      || this.item.isBookmark) {
        this.activeTab = !this.isItemBeingUpdated || this.item.color ? 1 : 0;
      } else {
        this.activeTab = !this.isItemBeingUpdated || !this.item.color ? 0 : 1;
      }
    },

    setPreviousColor() {
      this.previousColor = this.item.color || TEAL;
    },

    toggleActiveTab(index) {
      const tabName = index === 0 ? LOGO : COLOR;
      const isCustomLogo = this.appLogo
        || (this.item.logo.url && this.templateLogoUrl !== this.item.logo.url);

      if (tabName === COLOR && isCustomLogo) {
        ModalEventBus.open({
          component: 'ConfirmationModal',
          componentProps: {
            headerText: 'Select Color Indicator',
            bodyText: 'Are you sure? Selecting a color indicator will remove the previously uploaded image. If you want to switch back to a logo you will have to upload a new image.',
            handleContinue: () => this.handleContinue(tabName, index),
            showClose: true,
          },
          preventCloseOnOverlayClick: true,
        });
      } else {
        this.handleTabChange(tabName, index);
      }
    },
  },
};
</script>

<style module>
.avatarStyleContainer .tabHeader {
  margin: 0;
}

.avatarStyleContainer {
  display: block;
  position: relative;
}

.chooserLabel {
  display: block;
  font-weight: 600;
  margin: 0 0 0.5rem;
  text-transform: capitalize;
}

.navList li {
  background-color: var(--jcGrey100);
  border: 1px solid var(--jcGrey);
  border-radius: 0 4px 4px 0;
  padding: 5px 0;
  text-align: center;
}

.navList li.activeTabHeader {
  background-color: var(--jcPrimary);
}

.navList li:first-of-type .tabHeader {
  padding: 0 50px;
}

.navList li:first-of-type {
  border-radius: 4px 0 0 4px !important;
}

.navList a {
  font-weight: 600;
}

.tabContainer li a {
  font-size: 1rem;
  padding: 0 19px;
}
</style>
